import { DividerLook } from "../Divider.types";
const ComponentStyle = {
    baseStyle: {
        marginTop: "4",
        marginBottom: "4",
        borderHeight: "1px",
    },
    defaultProps: {
        look: DividerLook.PRIMARY,
    },
};
export default ComponentStyle;
//# sourceMappingURL=Divider.default.js.map